import React from 'react';
import { VCredit } from '../keno/VCredit';

export const MinesProfit = ({ round }) => {
  const multiplier = round.finished ? round.multiplier : round.current_multiplier;
  const profit = round.finished ? round.payout_minor - round.bet_minor : round.revealed.length ? round.cashout_minor - round.bet_minor : 0;
  return <div className="mines-profit" data-testid="mines-profit-panel">
    <label>Total Profit <span data-testid="mines-current-multiplier">({multiplier.toFixed(2)}×)</span></label>
    <div className={`mines-profit-value ${profit < 0 ? 'is-negative' : ''}`}><VCredit minor={profit} testid="mines-total-profit" /></div>
  </div>;
};